<div class="control-box">
    <div class="flex flex-col">
        <div class="control-box mb-0">
            <label for="search">{{ label }}</label>
            <form class="control-container lg:max-w-lg" (ngSubmit)="onSearch()" autocomplete="off" action="">
                <input class="control control-icon" type="text" name="search" [placeholder]="placeholder" [(ngModel)]="search" (input)="onKeyPress()">
                <i *ngIf="!search" class="fa-solid fa-magnifying-glass icon"></i>
                <i *ngIf="search" class="fa-solid fa-circle-xmark icon cursor-pointer" (click)="onClearField()"></i>
            </form>
        </div>
        <ul class="mx-4 border border-gray-300 shadow-md select-none" *ngIf="isLoading">
            <li class="border-gray-300 h-10 flex items-center px-5 py-2.5 hover:bg-gray-200">
                <p>Cargando...</p>
            </li>
        </ul>
        <ul class="mx-4 border border-gray-300 shadow-md select-none" *ngIf="!isLoading && data.length == 0 && search.length > 0 && searched">
            <li class="border-gray-300 min-h-10 flex items-center px-5 py-2.5 hover:bg-gray-200">
                <p>No se encontraron coincidencias</p>
            </li>
        </ul>
        <ul class="mx-4 border border-gray-300 shadow-md select-none" *ngIf="!isLoading && data.length">
            <li *ngFor="let item of data" class="cursor-pointer border-gray-300 min-h-10 h-fit flex items-center px-5 py-2.5 hover:bg-gray-200" style="word-break: break-all;" (click)="onSelectedRecord(item)">
                <p>{{ item[displayNameProp] }}</p>
            </li>
        </ul>
    </div>
</div>